import React from 'react';
import { theme } from '../styles/ThemeProvider';
import { LoaderCircle } from 'styled-icons/boxicons-regular/LoaderCircle';
import styled from 'styled-components';
import { RFC } from 'state/StateTypes';

interface Props {
   size?: number;
   color?: 'light' | 'dark';
}

const SmallLoader: RFC<Props> = ({ size = 13, color = 'dark' }): JSX.Element => (
   <Spinner>
      <LoaderCircle size={size} color={color === 'dark' ? theme.primaryBlueLight : theme.primaryWhite} fontWeight={300} className="spinner" />
   </Spinner>
);

export default SmallLoader;

const Spinner = styled.span`
   .spinner {
      animation: rotate 2s linear infinite;
   }

   @keyframes rotate {
      100% {
         transform: rotate(360deg);
      }
   }
`;
